module.exports = __webpack_public_path__ + "static/media/A2_16.1812cebd.png";